import React, { useState, useEffect } from 'react';
import ContentItemEmpty from '../../../pages/ContentPage/ContentList/ContentItemEmpty';

function CardImg({ name, className, url, largeThumb, smallThumb }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    if (error) {
      console.error(error);
      setError(null);
    }
  }, [url, largeThumb, smallThumb]);

  return !error && (largeThumb || smallThumb || url) ? (
    <img
      className={className}
      src={largeThumb || smallThumb || url}
      alt={name}
      height={125}
      onError={setError}
    />
  ) : (
    <ContentItemEmpty className={className} />
  );
}

export default CardImg;
